<template>
   <div >
       <el-button type="primary" plain icon="el-icon-connection" @click="()=>show = true" circle></el-button>
       <el-dialog show-close center title="小程序码"  :visible.sync="show" append-to-body>
            <div style="display: flex; justify-content: center; align-content: center;align-items: center">
                <el-image v-if="imgUrl" :preview-src-list="[imgUrl]"  :src="imgUrl"></el-image>

               <div v-else>
                   <el-button type="primary" @click="getQrcodeImg">生成小程序码</el-button>
               </div>
           </div>
       </el-dialog>
   </div>
</template>

<script>
import util from '@/libs/util'

export default {
  name: 'qrcode',
  props: {
    type: {
      type: Number,
      default: 0
    },
    params: {
      type: Object,
      default: {}
    }
  },
  watch: {
    type (newVal) {
      this.type = newVal
    },
    params (val) {
      this.params = val
    }
  },
  computed: {

  },
  data () {
    return {
      show: false,
      imgUrl: ''
    }
  },
  methods: {

    getQrcodeImg () {
      const token = util.cookies.get('token')
      const baseURL = process.env.VUE_APP_API
      this.$axios.post(baseURL + '/api/common/skip-type/qrcode/' + this.type, this.params, {
        responseType: 'blob', // 将 responseType 设置为 'blob'，以便将响应数据转换为 Blob 对象
        headers: {
          'Authorization': 'Bearer ' + token
        }
      }).then(res => {
        console.log('getQrcodeImg', res)
        const blob = new Blob([res.data], { type: 'image/jpeg' }) // 将响应数据转换为 Blob 对象
        // 将 Blob 对象转换为 Blob URL
        this.imgUrl = window.URL.createObjectURL(blob) // 将 Blob URL 赋值给 img 标签的 src 属性
      })
    }
  }

}
</script>

<style scoped>

</style>
